import React from "react";
import ForgotPasswordForm from "Components/home/ForgotPasswordForm";
import HeroImage from "Components/home/widgets/HeroImage";
import * as actions from "Actions";
import { connect } from "react-redux";

const textColor = (value, dark = '#0E2C44') =>
  value === 'light' ? '#FFFFFF' : dark;

class ForgotPassword extends React.Component {
  handleSubmit = data => {
    this.props.sendPasswordReset(data);
  };
  render() {
    const { storefrontEventsSetting } = this.props;
    const displayTitle =
      storefrontEventsSetting.forgotPasswordPageTitle || 'Password Reset';
    const displayBody =
      storefrontEventsSetting.forgotPasswordPageBody ||
      'Track rentals, make payments, request changes. You made it!';
    const headlineStyle = {
      color: textColor(storefrontEventsSetting.forgotPasswordHeadlineTextColor),
    };
    const bodyStyle = {
      color: textColor(
        storefrontEventsSetting.forgotPasswordBodyTextColor,
        '#466B88'
      ),
    };

    return (
      <section className="password">
        <HeroImage
          picture={storefrontEventsSetting.customerPortalPicture}
          alt={displayTitle}
        />
        <div className="details">
          <h1 style={headlineStyle}>{displayTitle}</h1>
          <p style={bodyStyle}>{displayBody}</p>
        </div>
        <div className="passwordForm">
          <ForgotPasswordForm onSubmit={this.handleSubmit} />
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => {
  const { parsedStorefrontSettings } = state.locations;
  return {
    storefrontEventsSetting: parsedStorefrontSettings.storefrontEventsSetting,
  };
};

export default connect(mapStateToProps, actions)(ForgotPassword);
